@if (currentFormHeader) {
<h4 class="form-title">{{ currentFormHeader.DESCRIPTION }}</h4>
}

<!-- Part I -->
<div class="table-scroll">
  <table class="table table-bordered custom-table form-inline">
    <tbody>
      <tr>
        <th class="sticky-col" style="width: 10rem">{{ tableHeader[0]?.LINE_NO || 'Line Number' }}</th>
        <th class="sticky-col" colspan="2">{{ tableHeader[0]?.DESCRIPTION || 'Description' }}</th>
        <th class="sticky-col" colspan="2">{{ tableHeader[0]?.ATTRIB_DESCRIPTION || 'Input' }}</th>
      </tr>

      @for (row of partIRows; track trackByLineAttribKey($index, row)) {
<tr class="table1">
        @if (row.ROW_TYPE !== 'PH') {
<td>{{ row.LINE_DISP }}</td>
}
        @if (row.ROW_TYPE === 'PH') {
<td class="color-red"><b>{{ row.LINE_DISP }}</b></td>
}

        @if (row.ROW_TYPE === 'PH') {
<td colspan="2" class="color-red"><b>{{ row.DESCRIPTION }}</b></td>
}
        @if (row.ROW_TYPE !== 'PH') {
<td colspan="2">{{ row.DESCRIPTION }}</td>
}

        @if (row.EDIT_TYPE !== 'radio') {

          @for (row1 of getPartIInputs(row.FORM_LINE_KEY); track trackByLineAttribKey($index, row1)) {
<td colspan="2" style="width: 220px;"
             >
            @if (row1.IS_EDITABLE_CELL === 'N' && row1.EDIT_TYPE !== 'radio') {
<div
                 style="text-align: right; padding-right: 10px;"
                 [class.color-red]="row1.ATTRIB_VALUE < 0">
              <span>{{ row1.ATTRIB_VALUE }}</span>
            </div>
}
            @if (row1.IS_EDITABLE_CELL === 'Y'
                       && row1.EDIT_TYPE !== 'checkbox'
                       && row1.EDIT_TYPE !== 'radio'
                       && row1.EDIT_TYPE !== 'custom_date_various'
                       && row1.EDIT_TYPE !== 'dropdown') {
<div
                 style="text-align: right; padding-right: 10px;">
              @if (row1.DATA_TYPE === 'number') {
<input
                     class="form-control input-md numText"
                     style="text-align: right"
                     type="text"
                     [ngModel]="row1.ATTRIB_VALUE"
                     (ngModelChange)="onTextChange(row1, $event)">
}
            </div>
}
          </td>
}
        
}

        @if (row.EDIT_TYPE === 'radio') {
<td colspan="2"
            style="width: 183px; text-align: center; padding-right: 10px;">
          @for (row1 of getPartIRadios(row.FORM_LINE_KEY); track trackByLineAttribKey($index, row1)) {
<div>
            <label>
              <input type="checkbox"
                     [checked]="row1.ATTRIB_VALUE === 'true'"
                     (change)="onRadioToggle(row1, $event)">
              {{ row1.ATTRIB_DESCRIPTION }}
            </label>
          </div>
}
        </td>
}
      </tr>
}
    </tbody>
  </table>
</div>

<div style="height: 12px;"></div>

<!-- Part II -->
<div class="table-scroll">
  <table class="table table-bordered custom-table form-inline">
    <tbody>
      <tr>
        @for (val of tableHeader; track $index; let first = $first) {
<th class="sticky-col"
            [style.width]="first ? '6%' : null">
          {{ val.ATTRIB_DESCRIPTION }}
        </th>
}
      </tr>

      @for (row of partIIRows; track trackByLineAttribKey($index, row)) {
<tr class="table1">
        @if (row.ROW_TYPE === 'PH') {
<td class="color-red"><b>{{ row.LINE_DISP }}</b></td>
}
        @if (row.ROW_TYPE === 'PH') {
<td colspan="3" class="color-red"><b>{{ row.DESCRIPTION }}</b></td>
}
        @if (row.ROW_TYPE !== 'PH') {
<td>{{ row.LINE_DISP }}</td>
}

        @for (row1 of getPartIIEditableInputs(row.FORM_LINE_KEY); track trackByLineAttribKey($index, row1)) {
<td
            style="width: 220px;">
          @if (row1.DATA_TYPE === 'string') {
<div>
            <input class="form-control input-md numText"
                   style="text-align: left"
                   type="text"
                   [ngModel]="row1.ATTRIB_VALUE"
                   (ngModelChange)="onTextChange(row1, $event)">
          </div>
}
          @if (row1.DATA_TYPE === 'dateVarious') {
<div>
            <gtw-credits-date-various
              [row]="row1"
              (changed)="onDateVariousChange(row1)">
            </gtw-credits-date-various>
          </div>
}
        </td>
}
      </tr>
}
    </tbody>
  </table>
</div>
